// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-toggle-wrapper {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.chatbot-toggle {
  background-color: #754ef9;
  color: white;
  border: none;
  padding: 12px 18px;
  border-radius: 30px;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.chatbot-wrapper {
  margin-top: 15px;
  width: 370px;
  max-height: 500px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.3);
}
`, "",{"version":3,"sources":["webpack://./src/Chatbot.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;AACxC","sourcesContent":[".chatbot-toggle-wrapper {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.chatbot-toggle {\n  background-color: #754ef9;\n  color: white;\n  border: none;\n  padding: 12px 18px;\n  border-radius: 30px;\n  font-size: 16px;\n  cursor: pointer;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.2);\n}\n\n.chatbot-wrapper {\n  margin-top: 15px;\n  width: 370px;\n  max-height: 500px;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
